// Ported from Protonet's jquery.inview
// https://github.com/protonet/jquery.inview/blob/master/jquery.inview.js

import { closest } from '../js-lib/domClosest'
import offset from '../js-lib/domOffset'

const w = window
const d = document
const { documentElement } = d

const inviewObjects = []

let viewportSize = null
let viewportOffset = null
let timer = null

function add (el, handler) {
	remove(el, handler)
	inviewObjects.push({ el, handler, inView: false })

	if (!timer) {
		timer = setInterval(checkInView, 250)
	}
}

function remove (el, handler) {
	const index = inviewObjects.findIndex(obj => obj.el === el && obj.handler === handler)
	if (index < 0) return
	inviewObjects.splice(index, 1)

	if (inviewObjects.length === 0) {
		clearInterval(timer)
		timer = null
	}
}

function once (el, handler) {
	const wrap = inview => {
		remove(el, wrap)
		handler(inview)
	}
	add(el, wrap)
}

function getViewportSize () {
	const size = {
		height: w.innerHeight,
		width: w.innerWidth
	}

	if (!size.height) {
		return {
			height: documentElement.clientHeight,
			width: documentElement.clientWidth
		}
	}

	return size
}

function getViewportOffset () {
	return {
		top: w.pageYOffset || documentElement.scrollTop || d.body.scrollTop,
		left: w.pageXOffset || documentElement.scrollLeft || d.body.scrollLeft
	}
}

function checkInView () {
	if (inviewObjects.length === 0) return

	viewportSize = viewportSize || getViewportSize()
	viewportOffset = viewportOffset || getViewportOffset()

	inviewObjects.forEach((inviewObject, index) => {
		const { el, handler, inView } = inviewObject
		if (!closest(documentElement, el)) return

		const elementSize = {
			height: el.offsetHeight,
			width: el.offsetWidth
		}
		const elementOffset = offset(el)

		// Don't ask me why because I haven't figured out yet:
		// viewportOffset and viewportSize are sometimes suddenly null in Firefox 5.
		// Even though it sounds weird:
		// It seems that the execution of this function is interferred by the onresize/onscroll event
		// where viewportOffset and viewportSize are unset
		if (!viewportOffset || !viewportSize) return

		const newInView = (
			elementOffset.top + elementSize.height > viewportOffset.top &&
			elementOffset.top < viewportOffset.top + viewportSize.height &&
			elementOffset.left + elementSize.width > viewportOffset.left &&
			elementOffset.left < viewportOffset.left + viewportSize.width)

		if (newInView === inView) return

		inviewObjects[index].inView = newInView
		handler(newInView)
	})
}

function resetViewport () {
	viewportSize = viewportOffset = null
}

window.addEventListener('scroll', resetViewport)
window.addEventListener('resize', resetViewport)
window.addEventListener('scrollstop', resetViewport)

export default {
	add,
	remove,
	once
}
